module.exports = __webpack_public_path__ + "img/goVotes.0fd008a6.png";